import { useMemo } from 'react'
import { useNavigation } from '@react-navigation/native'
import type { NavigationProp } from '@react-navigation/native'

import { useSelector } from 'APP/Hooks/redux'
import { memberTasksSelectors } from 'APP/Store/MemberTasks'

import { getMemberTaskDefinition } from './memberTaskDefinitions'
import type { MemberTaskBarItemModel } from './types'

/**
 * Builds the MemberTaskBar view-models for an episode
 */
export const useMemberTaskBar = (episodeId?: string): MemberTaskBarItemModel[] => {
  const navigation = useNavigation<NavigationProp<ReactNavigation.RootParamList>>()

  const tasks = useSelector((state) =>
    memberTasksSelectors.selectEpisodeMemberTasks(state, episodeId ?? '')
  )

  return useMemo(
    () =>
      tasks.map((task): MemberTaskBarItemModel => {
        const definition = getMemberTaskDefinition(task.task_experience)
        const id = definition.getId(task)

        return {
          type: task.task_experience,
          memberTask: task,
          id,
          onPress: () => navigation.navigate('nextMemberTaskScreen', { task }),
        }
      }),
    [tasks, navigation]
  )
}
